// extracted by mini-css-extract-plugin
export default {"main":"MyTeams_main__i8Bnf","header":"MyTeams_header__XB+AK","subtitle":"MyTeams_subtitle__SRnhz"};